import { render, staticRenderFns } from "./Allreferrals.vue?vue&type=template&id=e31c65fa&scoped=true&"
import script from "./Allreferrals.vue?vue&type=script&lang=js&"
export * from "./Allreferrals.vue?vue&type=script&lang=js&"
import style0 from "./Allreferrals.vue?vue&type=style&index=0&id=e31c65fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31c65fa",
  null
  
)

export default component.exports